import { Box, Typography } from '@mui/material';
import { Button } from 'components/ui';
import AppStoreIcon from '../../../assets/images/icons/app-store.svg';
import PlayStoreIcon from '../../../assets/images/icons/play-store.svg';

// ==============================|| MOBILE APP DOWNLOAD ||============================== //

const MobileAppDownload = () => {
  return (
    <Box
      sx={{
        py: 3,
        px: '30px'
      }}
    >
      <Box
        sx={{
          background: 'linear-gradient(90deg, #0B0F20 0%, #2d6a4f 100%)',
          borderRadius: 4,
          px: 2.5,
          py: 2
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" sx={{ color: 'white', fontSize: 16, fontWeight: 600, letterSpacing: '-0.04em' }}>
            Download
            <br />
            our Mobile App
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Box
              component="a"
              href="#"
              sx={{
                cursor: 'pointer',
                textDecoration: 'none',
                '&:hover': { opacity: 0.8 }
              }}
            >
              <img src={AppStoreIcon} alt="App Store" style={{ width: 20, height: 20 }} />
            </Box>
            <Box
              component="a"
              href="#"
              sx={{
                cursor: 'pointer',
                textDecoration: 'none',
                '&:hover': { opacity: 0.8 }
              }}
            >
              <img src={PlayStoreIcon} alt="Play Store" style={{ width: 20, height: 20 }} />
            </Box>
          </Box>
        </Box>
        <Button
          fullWidth
          onClick={() => {}}
          sx={{
            height: 32,
            fontSize: 13,
            minHeight: 'unset',
            padding: '6px 16px'
          }}
        >
          Coming Soon
        </Button>
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          display: 'block',
          textAlign: 'center',
          fontSize: 12,
          mt: 2
        }}
      >
        @ {new Date().getFullYear()} Traders Connect App Limited.
      </Typography>
    </Box>
  );
};

export default MobileAppDownload;
